import { useRef } from 'react';

function useProgress() {
  const progressRef = useRef<HTMLDivElement>(null);

  const updateProgressCircle = (p: any) => {
    const progress = Math.round((p.loaded / p.total) * 100);
    if (progressRef.current) {
      const circle = progressRef.current.querySelector(
        '.progress-ring-circle-completed',
      ) as SVGCircleElement | null;
      const label = progressRef.current.querySelector('.progress-label');
      if (circle && label) {
        const radius = circle.r.baseVal.value;
        const circumference = 2 * Math.PI * radius;
        const offset = circumference - (progress / 100) * circumference;
        circle.style.strokeDasharray = `${circumference} ${circumference}`;
        circle.style.strokeDashoffset = offset.toString();
        circle.style.display = 'block';
        label.textContent = `${progress}%`;
      }
    }
  };

  return { progressRef, updateProgressCircle };
}

export default useProgress;
